import React, {useState, useEffect} from 'react';
import { Button, message } from 'antd';
import '../style/login.less';
import SuspensionInput from "../components/SuspensionInput/Index";
import config from "../config";
import { useNavigate} from 'react-router-dom';
import { connect } from 'react-redux'
import mainBg from '../static/loginContent.png'
import {user} from "../api";

const Login = (props) => {
    const navigation = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(props.login) {
            navigation('/')
        }
    }, [props.login])

    const submit = async () => {
        setLoading(true);
        let {Status, Data, Message} = await user.UserLoginWithResult({
            Name: username,
            Pwd: password,
        });
        setTimeout(() => {
            let msg = Status === 10001 ? '登录成功！' : Message;
            message[Status === 10001 ? 'success' : 'warning'](msg)
            if(Status === 10001) {
                props.saveUserInfo(Data);
            }
            setLoading(false);
        }, 1000)
    }
    return(
        <div className="Login">
            <div className="Login-main">
                <img src={mainBg} width={1000} alt=""/>
                <div className="Login-main-content">
                    <h1>NB-IOT物联网商用平台</h1>
                    <h3>欢迎登录</h3>
                    <SuspensionInput label="用户名" change={v => setUsername(v)}></SuspensionInput>
                    <SuspensionInput label="密码" type="password" change={v => setPassword(v)}></SuspensionInput>
                    <Button type="primary" style={{marginTop: 44}} block loading={loading} onClick={submit}>
                        登录
                    </Button>
                </div>
            </div>
        </div>
    )
}

const stateToProps = (state) =>{
    return{
        login: state.login
    }
}

const dispathToProps = (dispatch) =>{
    return{
        saveUserInfo(data){
            const action ={
                type:'saveUserInfo',
                data
            }
            dispatch(action)
        },
    }
}
export default connect(stateToProps, dispathToProps)(Login);
